"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FormattedLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon/Icon");
var _FormattedDate = require("./FormattedDate");
var _FormattedCurrency = require("./FormattedCurrency");
var _DeviceWarranty = require("./formats/DeviceWarranty");
var _DeviceModel = require("./formats/DeviceModel");
var _Text = require("../Text/Text");
var _Image = _interopRequireDefault(require("../../Components/Image/Image"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable import/prefer-default-export */

// pass the data value and the display format
const FormattedLabel = ({
  data,
  config,
  labels,
  ...props
}) => {
  const {
    country,
    language,
    formats,
    type,
    onClick
  } = config;
  const {
    currency,
    date
  } = formats;
  try {
    switch (type.toLowerCase()) {
      // #region shared formatting

      case 'datetime':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedDate.FormattedDate, {
              config: {
                country,
                language,
                mask: date
              },
              data: data
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "datetime error"
            });
          }
        }
      case 'datetimehybrid':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: data[1]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedDate.FormattedDate, {
                config: {
                  country,
                  language,
                  mask: date
                },
                data: data[0]
              })]
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "datetimehybrid error"
            });
          }
        }
      case 'status':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "status",
              children: data[1]
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "status error"
            });
          }
        }
      case 'currency':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedCurrency.FormattedCurrency, {
              config: {
                country,
                language,
                mask: currency
              },
              data: data
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "currency error"
            });
          }
        }
      case 'orderlink':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "ccl-e-button ccl-e-button--text",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                color: "interactive",
                type: "chevron-right",
                size: "sm"
              })
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "orderlink error"
            });
          }
        }
      case 'equipmentlink':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "ccl-e-button ccl-e-button--text ccl-e-button--align-end",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                color: "interactive",
                type: "chevron-right",
                size: "sm"
              })
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "equipmentlink error"
            });
          }
        }
      case 'composite-equipment-information':
        {
          try {
            return (0, _DeviceModel.deviceModelMobileView)(labels, data);
            // return (
            //   <span>
            //     {(labels[data[0]] && labels[data[0]] + ": ")  || ""}{data[1]}
            //     <br />
            //     {labels[data[2]] || ""}: {data[3]} <br />

            //    {detailedMobileView(labels,data[4])}

            //   </span>
            // );
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "composite error"
            });
          }
        }
      case 'compositeinformation':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: [labels['labels.orders.cellDetails.part'], ": ", data[0], /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), data[5] ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [labels['labels.orders.cellDetails.hcpc'], ":", ' ', data[5], /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
              }) : '', data[1], " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), labels['labels.orders.cellDetails.status'], ": ", data[2], /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), data[3], " @", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedCurrency.FormattedCurrency, {
                config: {
                  country,
                  language,
                  mask: currency
                },
                data: data[4]
              }), ' ', labels['labels.orders.cellDetails.each']]
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "composite error"
            });
          }
        }

      /**
       * Clickable link
       */
      case 'link':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "ccl-e-link--text",
              onClick: () => onClick(data.id),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                content: data.item,
                type: "interactive-small-text"
              })
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "link error"
            });
          }
        }

      /**
       * toggle the collapsible row via an icon
       */
      case 'icontoggle':
        {
          try {
            if (data) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-e-button ccl-e-button--text",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  color: "interactive",
                  type: "chevron-right",
                  size: "sm",
                  rotate: config.show ? '90' : '',
                  onClick: () => config.setShow(!config.show)
                })
              });
            } else {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
            }
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "icontoggle error"
            });
          }
        }

      /**
       * toggle the collapsible row via a text
       */
      case 'texttoggle':
        {
          try {
            if (data) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-e-link--text",
                onClick: () => config.setShow(!config.show),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                  content: data.item,
                  type: "interactive-small-text"
                })
              });
            } else {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
            }
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "texttoggle error"
            });
          }
        }

      /**
       * Key value pair (displayed in collapsible row)
       */
      case 'keyvalue':
        {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: Object.keys(data).map(key => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "ccl-e-keyvalue",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                  content: `${labels[key]} : `,
                  type: "small-body-text-bold"
                }), "\xA0", data[key].type === 'datetime' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedDate.FormattedDate, {
                  config: {
                    country,
                    language,
                    mask: date
                  },
                  data: data[key].value
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                  content: data[key].value,
                  type: "small-body-text"
                })]
              }, key))
            });
          } catch (ex) {
            console.log(ex);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "keyvalue error"
            });
          }
        }

      // #endregion

      // #region device field formatting

      case 'device.model':
        {
          return (0, _DeviceModel.deviceModel)(labels, data);
        }
      case 'device.warranty':
        {
          try {
            return (0, _DeviceWarranty.deviceWarranty)(labels, data);
          } catch (ex) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "status error"
            });
          }
        }

      // #endregion

      case 'thumbnailwithtext':
        {
          try {
            var _data$1$img, _data$1$img2, _data$1$img3, _data$1$text, _data$1$img4, _data$1$img5, _data$1$text2, _data$1$text3;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "ccl-e-thumbnail-with-text",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "ccl-e-thumbnail-with-text__thumbnail",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
                  fluid: true,
                  bgColor: "transparent",
                  fallback: (_data$1$img = data[1].img) == null ? void 0 : _data$1$img.fallback,
                  src: (_data$1$img2 = data[1].img) == null ? void 0 : _data$1$img2.src,
                  alt: ((_data$1$img3 = data[1].img) == null ? void 0 : _data$1$img3.alt) || ((_data$1$text = data[1].text) == null ? void 0 : _data$1$text.content) || '',
                  width: ((_data$1$img4 = data[1].img) == null ? void 0 : _data$1$img4.width) || '50px',
                  height: ((_data$1$img5 = data[1].img) == null ? void 0 : _data$1$img5.height) || '50px'
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "ccl-e-thumbnail-with-text__text",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                  content: (_data$1$text2 = data[1].text) == null ? void 0 : _data$1$text2.content,
                  type: ((_data$1$text3 = data[1].text) == null ? void 0 : _data$1$text3.type) || 'body-text'
                })
              })]
            });
          } catch (ex) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "error"
            });
          }
        }
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: data ? data : '--'
        });
    }
  } catch (ex) {
    console.log(ex);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "error"
    });
  }
};
exports.FormattedLabel = FormattedLabel;
FormattedLabel.defaultProps = {
  config: {
    type: '',
    mask: '',
    cellDetails: {}
  },
  labels: {}
};